export const COMPETENCE_PATH = 'skill';
